export const FILTER_METHODS = {
  video_content: {
    key: "video_content",
    title: "Video Content Analysis",
    description: "AI will analyze the actual video content of the reel...",
    placeholders: [
      { key: "REELS_VIDEO", label: "Reels Video" },
      { key: "REELS_TEXT", label: "Reels Text" },
    ],
    isVideoAnalysis: true,
  },
  user_profile: {
    key: "user_profile",
    title: "User Profile Analysis",
    description: "AI will analyze the reel author's profile...",
    placeholders: [
      { key: "USER_BIO", label: "User Bio" },
      { key: "USER_FULLNAME", label: "User Full Name" },
      { key: "USER_USERNAME", label: "User Username" },
      { key: "USER_SCREENSHOT", label: "Profile Screenshot" },
    ],
    isVideoAnalysis: false,
  },
  reel_info: {
    key: "reel_info",
    title: "Reel Information Analysis",
    description: "AI will analyze the reel's text information...",
    placeholders: [
      { key: "REELS_INFO_TEXT", label: "Reel Info Text" },
      { key: "REELS_AUTHOR_USERNAME", label: "Reel Author Username" },
    ],
    isVideoAnalysis: false,
  },
};